module.exports = __webpack_public_path__ + "static/media/man-303792_640.d574fc46.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/man-303792_640.png
// module id = 116
// module chunks = 0